import React from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../components/Controls/InputField/InputField";
import * as actions from "../../store/programs/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const payload = { page: 1, sort: "created_at,desc" };
  
  const initialValues = {
    search: "",
  };
  const Filterchema = Yup.object().shape({
    search: Yup.string(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });
  
  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    dispatch(
      actions?.getProgramsRequest({
        ...payload,
        search: e.target.value,
      })
    );
    setSearchValues({search: formik.values.search});
  };

  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.users.search}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
